import React, { Component } from "react";
import Banner from "../../components/common/Banner";
import Header from "../../components/common/Header";
import Footer from "../../components/common/Footer";
import Loading from "../../components/common/Loading";
import NoData from "../../components/common/NoData";
import LifeAtBitSidebar from "./components/LifeAtBitSidebar";
import { doc, getDoc } from "firebase/firestore";
import { firestore } from "../../Config/FbConfig";
import { Modal } from "react-bootstrap";
import { Styles } from "./style/manthanActivities.js";
import { Styles as Styles1 } from "../placement/style/placementTeam";

export default class lifeatBitWellbeignCenter extends Component {
  state = {
    displayModal: false,
    modalImage: "",
    modalDescription: "",
    modalDate: "",
    modalVideo: "",
    Datas: [],
    Datas_1: [
      {
        id: "1",
        name: "Mr. Chethan J",
        designation: "Student Counsellor",
        image: "Wellbeign1.png",
        phone: "+91 9902468385",
        mailId: "chethanj@bit-bangalore.edu.in",
      },
      {
        id: "2",
        name: "Ms. Vidyashree H.V",
        designation: "Student Counsellor",
        image: "Wellbeign2.png",
        phone: "+91 9731055720",
        mailId: "vidyashreehv@bit-bangalore.edu.in",
      },
    ],
  };

  //Display Modal
  displayModal = (e) => {
    this.setState({
      displayModal: !this.state.displayModal,
    });
  };

  //Display Content
  contentModal = (e) => {
    var result = this.state.Datas.filter((x) => x.Id === e.target.id);
    this.setState({
      displayModal: !this.state.displayModal,
      modalImage: result[0]["Image"],
      modalDescription: result[0]["Description"],
      modalDate: result[0]["Year"],
      modalVideo: result[0]["Video"],
    });
  };

  //Load Data Here
  async componentDidMount() {
    const docRef = doc(firestore, "LifeBit", "Gallery");
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      var Data = [];
      Object.entries(docSnap.data()).forEach(([key, value]) => {
        Data.push(Object.assign({ Id: key }, value));
      });
      this.setState({
        Datas: Data,
      });
    } else {
      this.setState({
        Datas: "NO_999",
      });
    }
  }

  render() {
    console.log(this.state.Datas);
    return (
      <div>
        {/* Header */}
        <Header />

        {/* Banner */}
        <Banner title="Life@BIT" image="banners/banner-lifebit.jpg" />

        {/* Content */}
        <div className="sidebar ttm-sidebar ttm-bgcolor-white clearfix">
          <div className="container-xl">
            {/* row */}
            <div className="row">
              <div className="col-lg-9 content-area order-lg-2">
                <div className="ttm-service-single-content-area">
                  <div className="section-title with-desc text-left clearfix">
                    <div
                      className="title-header"
                      style={{ borderTopColor: "red" }}
                    >
                      <h4 className="title">Wellbeing Centre</h4>
                    </div>
                  </div>
                  <div className="ttm-service-description">
                    <div className="row">
                      <div className="col-md-5">
                        <div className="ttm_single_image-wrapper">
                          <img
                            className="img-fluid"
                            src={
                              process.env.PUBLIC_URL +
                              "/assets/images/lifebit/wellBeign3.jpg"
                            }
                            alt="single-img-eighteen"
                          />
                        </div>
                      </div>
                      <div
                        className="col-md-7 justify"
                        style={{ margin: "auto" }}
                      >
                        <p>
                          The Wellbeing Centre was established in the year 2023.
                          BIT Wellbeing Centre is a dedicated space designed to
                          support and promote the holistic well-being of our
                          students, faculty and non-teaching staff. We
                          understand that pursuing a technical education can be
                          intellectually and emotionally challenging. Our aim is
                          to provide the necessary psycho educational resources,
                          tools, and counselling support to help students,
                          faculty and non-teaching staff to maintain a healthy
                          balance between their academic, personal, and social
                          lives.
                        </p>
                      </div>
                      <div className="section-title with-desc text-left clearfix paddingtop-2">
                        <div
                          className="title-header paddingtop-2"
                          style={{ borderTopColor: "red" }}
                        >
                          <h5 className="title">Vision</h5>
                        </div>
                        <div className="col-md-6  col-lg-12 justify">
                          <ul className="ttm-list ttm-list-style-icon">
                            <li>
                              <i className=" ttm-textcolor-skincolor" />
                              <span className="ttm-list-li-content">
                                To foster a healthy and balanced learning
                                environment that promotes resilience, self-care,
                                and emotional intelligence among our students
                              </span>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="section-title with-desc text-left clearfix">
                        <div
                          className="title-header paddingtop-2"
                          style={{ borderTopColor: "red" }}
                        >
                          <h5 className="title">Mision</h5>
                        </div>
                        <div className="col-md-6  col-lg-12 justify">
                          <ul className="ttm-list ttm-list-style-icon">
                            <li>
                              <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                              <span className="ttm-list-li-content">
                                To promote holistic wellbeing among students.
                              </span>
                            </li>
                            <li>
                              <i className="  fa fa-check-circle ttm-textcolor-skincolor" />
                              <span className="ttm-list-li-content">
                                To provide support and psycho educational
                                resources to help students maintain a balance
                                between their academic, personal, and social
                                lives.
                              </span>
                            </li>
                            <li>
                              <i className=" fa fa-check-circle ttm-textcolor-skincolor" />
                              <span className="ttm-list-li-content">
                                To create a safe and inclusive space for
                                students to address their mental health concerns
                                and seek assistance.
                              </span>
                            </li>
                            <li>
                              <i className=" fa fa-check-circle ttm-textcolor-skincolor" />
                              <span className="ttm-list-li-content">
                                To raise awareness about mental health and
                                destigmatize seeking help.
                              </span>
                            </li>
                          </ul>
                        </div>
                      </div>

                      <div className="section-title with-desc text-left clearfix">
                        <div
                          className="title-header paddingtop-2"
                          style={{ borderTopColor: "red" }}
                        >
                          <h5 className="title">
                            Programs Under Wellbeing Centre
                          </h5>
                        </div>
                        <div className="row  justify">
                          <div className="col-md-6  col-lg-6 justify">
                            <ul className="ttm-list ttm-list-style-icon">
                              <li>
                                <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                                <span className="ttm-list-li-content">
                                  One to one Counselling
                                </span>
                              </li>
                              <li>
                                <i className="  fa fa-check-circle ttm-textcolor-skincolor" />
                                <span className="ttm-list-li-content">
                                  Group Counselling
                                </span>
                              </li>
                              <li>
                                <i className=" fa fa-check-circle ttm-textcolor-skincolor" />
                                <span className="ttm-list-li-content">
                                  Student Reboot Program – A program designed to
                                  address the students who are facing issues
                                  with clearing backlogs or are in the verge of
                                  being Drop outs.
                                </span>
                              </li>
                              <li>
                                <i className="  fa fa-check-circle ttm-textcolor-skincolor" />
                                <span className="ttm-list-li-content">
                                  Progressive pathway program - A program
                                  designed to address students who are facing
                                  issues with cracking placements.
                                </span>
                              </li>
                              <li>
                                <i className=" fa fa-check-circle ttm-textcolor-skincolor" />
                                <span className="ttm-list-li-content">
                                  Police Marshals - Students will be conducting
                                  Walkathons, Flash Mobs & Cultural events to
                                  spread awareness on COTPA act, Drug awareness
                                  and cyber security among community members in
                                  public Places.
                                </span>
                              </li>
                            </ul>
                          </div>
                          <div className="col-md-6  col-lg-6 justify">
                            <ul className="ttm-list ttm-list-style-icon">
                              <li>
                                <i className=" fa fa-check-circle ttm-textcolor-skincolor" />
                                <span className="ttm-list-li-content">
                                  Wellbeing Week
                                </span>
                              </li>
                              <li>
                                <i className=" fa fa-check-circle ttm-textcolor-skincolor" />
                                <span className="ttm-list-li-content">
                                  Vikasana – BIT Wellbeing Club (Link to be
                                  attached to Clubs of BIT Vikasana Page)
                                </span>
                              </li>
                              <li>
                                <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                                <span className="ttm-list-li-content">
                                  Student Illumination program – A program
                                  designed to address adjustment issues of
                                  students who have joined through lateral entry
                                  and rural background.
                                </span>
                              </li>

                              <li>
                                <i className=" fa fa-check-circle ttm-textcolor-skincolor" />
                                <span className="ttm-list-li-content">
                                  Wellbeing Advocates Program- Wellbeing
                                  Advocates are students who are trained with
                                  Psychological first aid with basic counselling
                                  skills to identify, address & to help find
                                  resources for those who are facing issues
                                  among their peers.
                                </span>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/*sports constitution*/}
                  <div className="section-title with-desc text-left clearfix">
                    <div
                      className="title-header paddingtop-2"
                      style={{ borderTopColor: "red" }}
                    >
                      <h5 className="title">Student Counsellors</h5>
                    </div>
                    <Styles1>
                      <div className="row ttm-service-msg">
                        {this.state.Datas_1.length == 0 ? (
                          <Loading />
                        ) : (
                          this.state.Datas_1.map((data, i) => (
                            <div
                              className="col-6 card"
                              style={{ marginBottom: "2rem" }}
                            >
                              <div className="row">
                                <div className="col-6">
                                  <img
                                    id={data.id}
                                    className="img-fluid"
                                    alt=""
                                    src={
                                      process.env.PUBLIC_URL +
                                      "/assets/images/lifebit/" +
                                      data.image
                                    }
                                    style={{
                                      borderRight: "solid 5px",
                                      borderColor: "#98002e",
                                    }}
                                  />
                                </div>
                                <div
                                  className="col-6"
                                  style={{ paddingTop: "12px" }}
                                >
                                  <div className="featured-title">
                                    <h6>{data.name}</h6>
                                    <small>{data.designation}</small>
                                  </div>
                                  <div className="post-meta">
                                    <p>{data.phone}</p>
                                  </div>
                                  <div className="post-meta">
                                    <p>{data.mailId}</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))
                        )}
                      </div>
                    </Styles1>
                  </div>

                  <div className="section-title with-desc text-left clearfix">
                    <div
                      className="title-header paddingtop-2"
                      style={{ borderTopColor: "red" }}
                    >
                      <h5 className="title">
                        Wellbeing Centre Events and Accomplishments
                      </h5>
                    </div>
                  </div>
                  <Styles>
                    <div className="row ttm-service-description paddingtop-1">
                      {this.state.Datas.length === 0 ? (
                        <Loading />
                      ) : this.state.Datas === "NO_999" ? (
                        <NoData />
                      ) : (
                        this.state.Datas.map((data, i) => (
                          <div
                            className="col-md-4 ttm-box-col-wrapper d-flex align-items-stretch"
                            key={i}
                            style={{ marginBottom: "1rem" }}
                          >
                            <div className="featured-imagebox featured-imagebox-blog">
                              <div className="featured-thumbnail">
                                <a onClick={this.contentModal}>
                                  <img
                                    id={data.Id}
                                    className="img-fluid"
                                    alt=""
                                    src={data.Image}
                                  />
                                </a>
                              </div>
                              <div className="featured-content">
                                <div className="ttm-box-post-date">
                                  <span className="ttm-entry-date">
                                    <time className="entry-date">
                                      {data.Year}
                                    </time>
                                  </span>
                                </div>
                                <div className="featured-desc justify">
                                  <p>{data.Description}</p>
                                </div>
                                {data.Video != undefined ? (
                                  <div
                                    className="post-meta"
                                    style={{ marginBottom: "-1rem" }}
                                  >
                                    <a target="_blank" href={data.Video}>
                                      <span
                                        className="ttm-meta-line"
                                        style={{ color: "gray" }}
                                      >
                                        <i className="fa fa-link" />
                                        View Details
                                      </span>
                                    </a>
                                  </div>
                                ) : null}
                              </div>
                            </div>
                          </div>
                        ))
                      )}
                    </div>
                  </Styles>
                </div>
              </div>
              <div className="col-lg-3 widget-area">
                <LifeAtBitSidebar />
              </div>
            </div>
          </div>
        </div>

        {/* Modal */}
        <Modal
          size="lg"
          show={this.state.displayModal}
          onHide={this.displayModal}
          centered
        >
          <Modal.Header closeButton></Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-5">
                <img
                  className="img-fluid"
                  alt=""
                  src={this.state.modalImage}
                  style={{ borderRight: "solid 5px", borderColor: "#98002e" }}
                />
              </div>
              <div className="col-7" style={{ padding: "1rem" }}>
                <div className="post-meta justify">
                  <p>{this.state.modalDescription}</p>
                </div>
                <div className="date" style={{ color: "#98002e" }}>
                  {this.state.modalDate}
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        {/* Footer */}
        <Footer />
      </div>
    );
  }
}
